export default __webpack_public_path__ + "static/media/Punto_00_Darsena_Nuova_FRA_Def.d710b4ca.aac";